<template>
  <div class="pending__lab_test">
    <LabTestTable :labTests="lab_tests" :data.sync="data" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import LabTestTable from '@/views/lab-tests/components/LabTestTable.vue'

export default {
  name: 'PendingLabTest',

  components: {
    LabTestTable
  },

  data() {
    return {
      data: {
        order: [],
        length: 10,
        page: 1,
        search: '',
        pending: 'pending'
      }
    }
  },

  async mounted() {
    await this.getAllLabTests() //get all lab tests

    this.$root.$on('updateLabTestList', () => this.getAllLabTests())
  },
  computed: {
    ...mapState('lab_test', ['lab_tests'])
  },
  methods: {
    ...mapActions('lab_test', { fetchAllLabTests: 'getLabTest' }),

    async getAllLabTests() {
      try {
        const { order, length, page, search, pending } = this.data

        await this.fetchAllLabTests({
          order,
          limit: length,
          page,
          search,
          pending
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },

  watch: {
    data() {
      this.getAllLabTests()
    }
  }
}
</script>

<style></style>
